export const buildProvenance = { "commitHash": "f42486118dbe8ad8323a762e3004b9e13624f4a0", "branchName": "refs/heads/release/2025.2", "buildDate": "2025-09-02T16:08:09.201Z", "version": "2025.2.13066" };
